import React, { Component } from 'react'
import moment from 'moment';
import { CURRENCY, Datos_Empresa, FORMAT_NUMBER, SYMBOL } from "../../libs/utils/Const";
import { development } from "../../libs/utils/Const";
import config from "../../config";

class SecretReport extends Component {

    render() {
        const { ArrayInfo, DeliveriesHouse, BiggestTotal,arrSessions,arrORQT, reprint, user, time } = this.props
        const today = moment(new Date()).format('YYYY-MM-DD');
        const _user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
   
        return (
            <div className='mt-5' style={{ height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginBottom: "100px" }}>
                <div className="row">
                    <div className="col-3">
                        <img src={development ? require('../../images/logo_draft.svg') : require('../../images/logo_EMPRESA.svg')} alt="Logo" />
                        <p className="text-center">{Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}<br /><strong></strong></p>

                    </div>
                    <div className="col-6 text-center">
                        <h5><strong>REPORTE OCULTO</strong></h5>
                    </div>
                    <div className="col-3">
                        <p>Sucursal: {_user?.Branch.CodeBranchOffice ?? ''}</p>
                        <p>FECHA DE CIERRE: <br/>{today}</p>
                    </div>
                </div>
                <div className='row mt-4' style={{ paddingRight: "15px" }}>
                    <table>
                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                            <tr>
                                <th className="text-center" colSpan="2">MOVIMIENTOS</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                {arrSessions && arrSessions.length> 0 &&
                arrSessions.map((sesion,index)=>{
                    return(
                        <>
                        <div>
                            <table className='mt-3'>
                                <thead >
                                    <tr style={{ borderBottom: "solid 1px" }}>
                                        <th className="text-left" colSpan="2">{sesion ? `${sesion.USER_CODE} -- ${sesion.U_NAME}. -- ID Sesión:  ${sesion.idSession}.` : ''}</th>
                                    </tr>
                                    <tr>
                                    <th className="text-center">
                                            TIPO DOCUMENTO
                                        </th>
                                        <th className="text-center">
                                            FOLIO
                                        </th>                                        
                                        <th className="text-center">
                                            CODIGO DE CLIENTE
                                        </th>
                                        <th className="text-center">
                                            FECHA
                                        </th>
                                        <th className="text-center">
                                            TOTAL
                                        </th>
                                    </tr>                                    
                                 

                                </thead>                
                                <tbody>
                                {sesion && sesion.body && sesion.body.allReport &&
                                                    sesion.body.allReport.map((movement, index) => {
                                                        return (
                                                            <>
                                                            <tr>
                                                                <td className="text-center" style={{ width: "16vw" }}>{movement.docObjectType ?? ''}</td>
                                                                <td className="text-center" style={{ width: "16vw" }}>{movement.folio ?? ''}</td>                                                                
                                                                <td className="text-center" style={{ width: "16vw" }}>{movement.cardCode ?? ''}</td>
                                                                <td className="text-center" style={{ width: "16vw" }}>{movement.docDate ?? ''}</td>                                                                
                                                                <td className="text-center mr-2">{CURRENCY + ' ' + FORMAT_NUMBER.new(movement.docTotal ?? 0)}</td>
                                                            </tr>                                                                                                                       
                                                            </>
                                                        )
                                                    })
                                                }                                
                                </tbody>
                            </table>
                        </div>
                        </>
                    )
                })
                }
                <div className='row mt-4' style={{ paddingRight: "15px" }}>
                    <table>
                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                            <tr>
                                <th className="text-center" colSpan="2">PEDIDOS Y COTIZACIONES</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                {arrORQT && arrORQT.length > 0 &&
                    arrORQT.map((doc,index)=>{
                        return(
                            <>
                            <div>
                            <table className='mt-3'>
                                <thead >
                                    <tr style={{ borderBottom: "solid 1px" }}>
                                        <th className="text-left" colSpan="2">{doc ? `${doc.USER_CODE} -- ${doc.U_NAME}. -- ID Sesión:  ${doc.idSession}.` : ''}</th>
                                    </tr>
                                    <tr>
                                    <th className="text-center">
                                            TIPO DOCUMENTO
                                        </th>
                                        <th className="text-center">
                                            FOLIO
                                        </th>                                        
                                        <th className="text-center">
                                            CODIGO DE CLIENTE
                                        </th>
                                        <th className="text-center">
                                            FECHA
                                        </th>
                                        <th className="text-center">
                                            TOTAL
                                        </th>
                                    </tr>                                    
                                 

                                </thead>                
                                <tbody>
                                {doc && doc.body && doc.body.allReport &&
                                                    doc.body.allReport.map((movement, index) => {
                                                        return (
                                                            <>
                                                            <tr>
                                                                <td className="text-center" style={{ width: "16vw" }}>{movement.docObjectType ?? ''}</td>
                                                                <td className="text-center" style={{ width: "16vw" }}>{movement.folio ?? ''}</td>                                                                
                                                                <td className="text-center" style={{ width: "16vw" }}>{movement.cardCode ?? ''}</td>
                                                                <td className="text-center" style={{ width: "16vw" }}>{movement.docDate ?? ''}</td>                                                                
                                                                <td className="text-center mr-2">{CURRENCY + ' ' + FORMAT_NUMBER.new(movement.docTotal ?? 0)}</td>
                                                            </tr>                                                                                                                       
                                                            </>
                                                        )
                                                    })
                                                }                                
                                </tbody>
                            </table>
                        </div>
                            </>
                        )
                    })

                }
                {ArrayInfo && ArrayInfo.length > 0 &&
                    ArrayInfo.map((user, index) => {
                        return (
                            <>
                                <div className='row mt-4' style={{ paddingRight: "15px" }}>
                                    
                                    <table className='mt-3'>
                                        <thead >
                                            <tr style={{ borderBottom: "solid 1px" }}>
                                                <th className="text-left" colSpan="2">{user ? `${user.USER_CODE} -- ${user.U_NAME}. -- ID Sesión:  ${user.idSession}.` : ''}</th>
                                            </tr>
                                        </thead>

                                    </table>

                                    <div className='pl-5' style={{ width: "100%" }}>

                                        <table className='mt-2'>
                                            <thead >
                                                <tr>
                                                    <th className="text-left" colSpan={4}>Venta</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {user && user.body && user.body.reportcashCut &&
                                                    user.body.reportcashCut.map((saleByPayMethod, index) => {
                                                        return (
                                                            <tr>
                                                                <td className="text-left" style={{ width: "16vw" }}>{saleByPayMethod.Type ?? ''}</td>
                                                                <td className="text-left" style={{ width: "16vw" }}>Venta</td>
                                                                <td className="text-center">{saleByPayMethod.Name ?? ''}</td>
                                                                <td className="text-right mr-2">{CURRENCY + ' ' + FORMAT_NUMBER.new(saleByPayMethod.Amount ?? 0)}</td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                                <tr>
                                                    <td className="text-left"></td>
                                                    <td className="text-left"></td>
                                                    <td className="text-center"></td>
                                                    <td className="text-right mr-2"></td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={2}></td>
                                                    <td className='text-right'><strong>Total Concepto: </strong></td>
                                                    <td className='text-right mr-2'><strong>{CURRENCY + ' ' + FORMAT_NUMBER.new(user.body.totalAmountSales ?? 0)}</strong></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <table className='mt-2'>
                                            <thead >
                                                <tr>
                                                    <th className="text-left" colSpan={4}>Devolución</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                <tr>
                                                    <td className="text-left" style={{ width: "16vw" }}>04</td>
                                                    <td className="text-left" style={{ width: "16vw" }}>Devolución</td>
                                                    <td className="text-center"></td>
                                                    <td className="text-right mr-2">{CURRENCY + ' - ' + FORMAT_NUMBER.new(user.body.negativeReturns ?? 0)}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={2}></td>
                                                    <td className='text-right'><strong>Total Concepto: </strong></td>
                                                    <td className='text-right mr-2'><strong>{CURRENCY + ' - ' + FORMAT_NUMBER.new(user.body.negativeReturns ?? 0)} </strong></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className='row mt-3'>
                                    <div className='col-5'></div>
                                    <div className='col-7'>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td className='text-right' style={{background: "#ddd"}}><strong>Total Usuario {user ? `${user.USER_CODE} - Sesión:  ${user.idSession}:` : ''} </strong></td>
                                                    <td className='text-right mr-2' style={{background: "#ddd"}}><strong>{CURRENCY + ' ' + FORMAT_NUMBER.new(user.body.totalCashCut ?? 0)}</strong></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </>
                        )
                    })
                }
                <div className='row mt-4'>
                    <div className='col-7'></div>
                    <div className='col-5'>
                        <table>
                            <tbody style={{ borderTop: "solid 1px"}}>
                                <tr>
                                    <td className='text-right p-2' style={{background: "#ddd"}}><strong>GRAN TOTAL: </strong></td>
                                    <td className='text-right p-2 mr-2' style={{background: "#ddd"}}><strong>{CURRENCY + ' ' + FORMAT_NUMBER.new(BiggestTotal ?? 0)}</strong></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className='row mt-5' style={{ paddingRight: "15px" }}>
                    <table>
                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                            <tr>
                                <th className="text-center" colSpan="2">VENTAS A DOMICILIO NO COBRADAS</th>
                            </tr>
                        </thead>

                    </table>

                    <table className='mt-2'>
                        <thead>
                            <tr>
                                <th className="text-left ml-5">Folio</th>
                                <th className="text-left">cliente</th>
                                <th className="text-left">Nombre del cliente</th>
                                <th className="text-center">Tipo</th>
                                <th className="text-center">Total</th>

                            </tr>
                        </thead>

                        <tbody>
                            {DeliveriesHouse && DeliveriesHouse.length > 0 &&
                                DeliveriesHouse.map((deliveryDoc, index) => {
                                    return (
                                        <tr>
                                            <td className="text-left">{deliveryDoc.folio ?? ''}</td>
                                            <td className="text-left">{deliveryDoc.cardCode ?? ''}</td>
                                            <td className="text-left">{deliveryDoc.CardName ?? ''}</td>
                                            <td className="text-center mr-2">DH</td>
                                            <td className="text-right">{CURRENCY + ' ' + FORMAT_NUMBER.new(deliveryDoc.docTotal ?? 0)}</td>
                                        </tr>
                                    )
                                })
                            }
                            <tr>
                                <td className="text-left">--</td>
                                <td className="text-left">--</td>
                                <td className="text-left">--</td>
                                <td className="text-center mr-2">--</td>
                                <td className="text-right">--</td>
                            </tr>
                        </tbody>
                    </table>

                </div>

                <br />
                <br />
                <br />
            </div >
        )
    }
}

export default SecretReport